import { Injectable } from "@angular/core";
import { API_METHODS, API_URL, OperationType, ROUTE_PATH, USER_TYPE } from "common/constants/sm-constants";
import { SystemService } from "../../../../core-services/system.service";
import { FormDataService } from "../../../base-data-services/form-data.service";
import { SmApiService } from "../../../../core-services/sm-api.service";
import { environment } from "src/environments/environment";
import { ForgotPasswordModel } from "common/models/page-models/Login/forgot-password/forgot-password-data-model";


@Injectable({
    providedIn: 'root'
})
export class ForgotPasswordFormDataService extends FormDataService<ForgotPasswordModel> {
    router: any;
    constructor(http: SmApiService, protected override ss: SystemService) {
        super(API_URL.forgotPassword, http, ss);

    }

    createInstance(): ForgotPasswordModel {
        return new ForgotPasswordModel();
    }

    // override modifyPostModel(formModel: any, dataModel: any) {
    //     const data = {
            
    //         email: dataModel.email
    //     }
    //     return data;
    // }

    override modifyPostModel(formModel: any, dataModel: any) {
        const data = {
            'email' : formModel.email,
            
        }
        return data;
    }

    override getEditUrlAndMethod() {
        const edit = {
            url: environment.apiUrl + '',
            method: API_METHODS.get
        }
        return edit;
    }

    // override getCustomError(): string {
    //     return 'Please enter correct Email ID';
    // }

}